import { useCallback } from 'react';
import { useDocumentationApiFacade } from '../../../apis/facades/useDocumentationApiFacade';
import { telemetry } from '../../../telemetry';
import { createConfigurationItemFromParserResponseItem } from '../../parser/parserUtils';
import { LAYOUT } from '@server/parser';
import { setRelatedListsAndButtons } from '../../../reducers/documentation/salesforceDocumentationReducer';
import { useDispatch } from 'react-redux';
import { SalesforceItemLayout } from '../../parser/ConfigurationItemTypes';

export const useLayouts = () => {
  const { get_layout } = useDocumentationApiFacade();
  const dispatch = useDispatch();

  const fetchLayoutData = useCallback(
    async (metadataId: string) => {
      try {
        const response = await get_layout(metadataId);
        const newConfigurationItem = createConfigurationItemFromParserResponseItem({
          responseItem: response,
          objectApiName: response.objectName,
          keyType: LAYOUT,
        }) as SalesforceItemLayout;
        dispatch(
          setRelatedListsAndButtons({
            metadataId,
            lists: newConfigurationItem.relatedLists ?? [],
            buttons: newConfigurationItem.buttons ?? [],
          }),
        );
      } catch (error) {
        telemetry.captureError(`Error during layout fetch for metadataId ${metadataId}`, error);
      }
    },
    [get_layout, dispatch],
  );

  return { fetchLayoutData };
};
